import { Button, Group } from '@mantine/core';

/**
 * «Назад / дальше» для курсорного списка (AD-A8). Состояние — у экрана: стек курсоров,
 * которые он уже прошёл; кнопка «дальше» есть, только пока API даёт `nextCursor`.
 */
export function Pager({
  canGoBack,
  canGoForward,
  onBack,
  onForward,
  loading,
}: {
  canGoBack: boolean;
  canGoForward: boolean;
  onBack: () => void;
  onForward: () => void;
  loading?: boolean;
}) {
  return (
    <Group justify="flex-end" gap="xs">
      <Button variant="default" size="xs" disabled={!canGoBack || loading} onClick={onBack}>
        Назад
      </Button>
      <Button variant="default" size="xs" disabled={!canGoForward || loading} onClick={onForward}>
        Дальше
      </Button>
    </Group>
  );
}
